import React from "react";
import ZendeskSettingContainer from "./ZendeskSettingContainer";

export default function ZendeskSetting({msgDataSources, mode}) {
    return (
        <>
            {
                msgDataSources && msgDataSources?.map((msgDataSource, index) =>
                    <ZendeskSettingContainer
                        key={index}
                        msgDataSource={msgDataSource}
                        mode={mode}
                    />
                )
            }
        </>
    )
}